import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { commonAppConfig } from '@ui/layout/common-app/common-app.config';
import { AppRoutingModule } from './app-routing.module';
import { ThirdLevelMenuFactory } from '@core/menu/third-level-menu.service';
import { thirdLevelMenu } from './sub.menu';
import { B2bProgramsState } from './shared/state/b2b-programs-state';
import { UserState } from '@core/state/user.state';
import { filter } from 'rxjs';


export const loadSubMenu: (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () => Promise<boolean> =
    (thirdLevelMenuFactory: ThirdLevelMenuFactory) => () =>
        thirdLevelMenuFactory.loadMenu(thirdLevelMenu);

export const initializeB2bPrograms: (b2bProgramsState: B2bProgramsState, userState: UserState) => () => void =
    (b2bProgramsState: B2bProgramsState, userState: UserState) => () => {
        userState.isAuthorized$.pipe(filter(Boolean)).subscribe(() => {
            b2bProgramsState.requestPrograms();
        });
    };

export const appConfig: ApplicationConfig = mergeApplicationConfig(commonAppConfig, {
    providers: [
        importProvidersFrom(AppRoutingModule),
        {
            provide: APP_INITIALIZER,
            useFactory: loadSubMenu,
            deps: [ThirdLevelMenuFactory],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeB2bPrograms,
            deps: [B2bProgramsState, UserState],
            multi: true,
        },
    ],
});
